import React, { useState } from 'react';
import Chat from './Chat';
import './ChatBubble.css';

const ChatBubble: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className={`chat-bubble-panel ${isOpen ? 'open' : ''}`}>
        <div className="chat-bubble-header">
          <span>💬 Chat</span>
          <button className="chat-bubble-close" onClick={() => setIsOpen(false)}>✕</button>
        </div>
        <div className="chat-bubble-body">
          <Chat />
        </div>
      </div>
      <button
        className={`chat-bubble-trigger ${isOpen ? 'hidden' : ''}`}
        onClick={() => setIsOpen(true)}
        title="Open Chat"
      >
        💬
      </button>
    </>
  );
};

export default ChatBubble;
